module.exports = __webpack_public_path__ + "static/media/VPM_laptop_4.09ed2bfb.jpg";